import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { FirestoreService } from 'common-lib';

@Component({
  selector: 'invalid-profile-modal',
  templateUrl: './invalid-profile-modal.component.html',
  styleUrls: ['./invalid-profile-modal.component.scss'],
})
export class InvalidProfileModalComponent implements OnInit, OnDestroy {
  constructor(private fire: FirestoreService, private auth: AngularFireAuth, private router: Router) {}

  @Input() isValidProfile = false;
  @Output() closeEvent = new EventEmitter<boolean>();

  ignoreClose: boolean = true;

  get onShow() {
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    document.body.style.overflow = 'hidden';
    return this.isValidProfile;
  }

  ngOnInit() {}

  ngOnDestroy() {
    document.removeEventListener('touchmove', this.handleTouchMove);
    document.body.style.overflow = '';
  }

  close() {
    this.isValidProfile = false;
    this.setTimestamp();
  }

  submit() {
    this.isValidProfile = false;
    this.router.navigate(['/profile/step1']);
    this.setTimestamp();
  }

  async setTimestamp() {
    const profile = this.fire.doc('profiles/' + this.auth.auth.currentUser.uid);
    profile.ref.set(
      {
        modalClosedAt: this.fire.timestamp,
      },
      { merge: true }
    );
  }

  handleTouchMove(event) {
    event.preventDefault();
  }
}
